module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "mt-3"
  }, [_vm._v("Resources / Capacity")]), _vm._v(" "), _c('div', {
    staticClass: "row mt-5"
  }, [_c('div', {
    staticClass: "scheduleTypeHolder col-sm-10 d-flex align-items-center mb-3"
  }, _vm._l((_vm.availabilityTypes), function(availabilityType) {
    return _c('button', {
      staticClass: "btn tertiary",
      class: {
        'selected': _vm.getSelectedEvent.availabilityType == availabilityType.value
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.setAvailabiltyType(availabilityType)
        }
      }
    }, [_vm._v(_vm._s(availabilityType.label))])
  }), 0), _vm._v(" "), (_vm.getSelectedEvent.availabilityType == 2) ? _c('div', {
    staticClass: "col-sm-10"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mt-2 mb-3 fs-small dark"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('radio', {
    staticClass: "d-inline",
    attrs: {
      "value": 0,
      "disabled": _vm.getSelectedEvent.isPrivateEvent == true || _vm.getSelectedEvent.shareType == 2
    },
    model: {
      value: (_vm.getSelectedEvent.shareType),
      callback: function($$v) {
        _vm.$set(_vm.getSelectedEvent, "shareType", $$v)
      },
      expression: "getSelectedEvent.shareType"
    }
  }, [_vm._v("\n                  NO"), _c('br')])], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex mt-2"
  }, [_c('radio', {
    staticClass: "d-inline",
    attrs: {
      "value": 1,
      "disabled": _vm.getSelectedEvent.isPrivateEvent == true || _vm.getSelectedEvent.shareType == 2
    },
    model: {
      value: (_vm.getSelectedEvent.shareType),
      callback: function($$v) {
        _vm.$set(_vm.getSelectedEvent, "shareType", $$v)
      },
      expression: "getSelectedEvent.shareType"
    }
  }, [_vm._v("\n                  YES. Products that use the same resource at the same time will share availability. You can set max.seats per product."), _c('br')])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.getSelectedEvent.availabilityType == 0) ? _c('div', {
    staticClass: "col-sm-10 d-flex align-items-center mb-3"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n              Total Capacity\n              "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.getSelectedEvent.maximumLotation),
      expression: "getSelectedEvent.maximumLotation"
    }],
    staticClass: "bg-lighter mt-1",
    attrs: {
      "type": "text",
      "size": "2"
    },
    domProps: {
      "value": (_vm.getSelectedEvent.maximumLotation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.getSelectedEvent, "maximumLotation", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.getSelectedEvent.eventResources), function(resource, index) {
    return _c('div', {
      staticClass: "row align-items-center mt-2"
    }, [_c('div', {
      staticClass: "col-sm-6"
    }, [_c('v-select', {
      staticClass: "mr-2",
      attrs: {
        "options": _vm.tweakedResources,
        "label": "name"
      },
      on: {
        "input": function($event) {
          return _vm.resouceSelected(_vm.getSelectedEvent.eventResources[index])
        }
      },
      model: {
        value: (_vm.getSelectedEvent.eventResources[index]),
        callback: function($$v) {
          _vm.$set(_vm.getSelectedEvent.eventResources, index, $$v)
        },
        expression: "getSelectedEvent.eventResources[index]"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-sm-4 text-right d-flex align-items-center"
    }, [(_vm.getSelectedEvent.availabilityType == 2) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (resource.maxSeats),
        expression: "resource.maxSeats"
      }],
      staticClass: "mr-1",
      staticStyle: {
        "width": "55px"
      },
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (resource.maxSeats)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(resource, "maxSeats", $event.target.value)
        }
      }
    }), _vm._v("\n                  /\n              ")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(resource.availability))])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2"
    }, [_c('i', {
      staticClass: "ico ico-delete largest dark pointer",
      on: {
        "click": function($event) {
          return _vm.removeResource(index)
        }
      }
    })]), _vm._v(" "), (resource.isAvailable !== undefined && !resource.isAvailable) ? _c('div', {
      staticClass: "col-sm-12"
    }, [_c('span', {
      staticClass: "color-6 fs-small font-weight-600"
    }, [_vm._v("Warning! This resource is already in use at this time")])]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-5"
  }, [_c('span', {
    on: {
      "click": _vm.addResource
    }
  }, [_c('span', {
    staticClass: "ico-add color-1 mr-1 rounded-circle border-color-1 p-1 pointer"
  }), _vm._v(" "), _c('label', {
    staticClass: "pointer"
  }, [_vm._v("Add New")])])]), _vm._v(" "), (_vm.validations.getSelectedEvent.resources.$invalid) ? _c('div', {
    staticClass: "color-6 my-2"
  }, [_vm._v("\n          If availbility is \"Limited by resources\" then you need at least one resource.\n      ")]) : _vm._e()], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex align-items-start"
  }, [_c('span', [_vm._v("Share availability with other products")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                      Resources for this event\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', [_vm._v("Capacity limit")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-74b4f597", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74b4f597"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/EventEdit/areaResources.vue
// module id = 935
// module chunks = 0